// --------------------------------------------------------
// COMPONENT_NAME - ComponentNameInPascalCase
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useState } from 'react'
import Colors from '../../constants/Colors'
import { ListItemContainer, Table, TableData, TextLink, Text } from '../UI/generalLayout/Layout.styled'
import { ReactComponent as Block } from '../../assets/imgs/protectionLock.svg'
import { ReactComponent as Unblock } from '../../assets/imgs/protectionLockOpen.svg'
import { ReactComponent as TrashBin } from '../../assets/imgs/trashBin.svg'
import { StyledCheckbox, StyledText } from './AgendaMesHorarioListItem.styled'
import { Paths } from '../../enums/Paths'
import { useNavigate } from 'react-router-dom'
import Agenda from '../../models/core/agenda/Agenda'
import { Tooltip } from '@mui/material'
import GenericModal from '../genericModal/GenericModal'
import { MobileContainer } from '../companyListItem/CompanyListItemMobile.styled'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// COMPONENT_NAME INTERFACE
// --------------------------------------------------------

interface IAgendaMesHorarioListItem {
    data: any;
    nome: string;
    agenda: Agenda;
    profissionalInfo: any;
    isAgendaDiaria?: boolean;
    isOnSelectedList: boolean;
    addObjectToSelectedList: () => void;
    deleteAgendaTurnoDia: (agendaId: string, turnoDiaId: string) => void;
    deleteAgendaTurnoDiaHorario: (agendaId: string, turnoDiaId: string, turnoDiaHorarioId: string) => void;
    activateInactivateAgendaMesDiaHorario: (agendaId: string, turnoDiaId: string, turnoDiaHorarioId: string, isActivate: boolean) => void;
    activateInactivateAgendaMesHorario: (agendaId: string, turnoDiaId: string, isActivate: boolean) => void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const AgendaMesHorarioListItem = (
    { data,
        nome,
        agenda,
        profissionalInfo,
        isAgendaDiaria = false,
        isOnSelectedList,
        addObjectToSelectedList,
        deleteAgendaTurnoDia,
        activateInactivateAgendaMesHorario,
        deleteAgendaTurnoDiaHorario,
        activateInactivateAgendaMesDiaHorario
    }: IAgendaMesHorarioListItem) => {
    // --------------------------------------------------------
    // COMPONENT_NAME PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const navigate = useNavigate()
    const [showModalInactivate, setShowModalInactivate] = useState(false)
    const [isBlockAction, setIsBlockAction] = useState(false)
    const [isDeleteAction, setIsDeleteAction] = useState(false)
    const { isMobile } = useResponsiveInfo()
    const isActive = !data.inativo;

    const ActionsArea = () => {
        return <>
            <Tooltip title={isActive ? 'Bloquear' : 'Desbloquear'}>
                {isActive ? (<Block
                    style={{ marginRight: 15, opacity: data.ativavel ? 1 : '0.5', cursor: data.ativavel ? 'pointer' : 'default' }}
                    onClick={data.ativavel ? () => { setShowModalInactivate(true); setIsBlockAction(true); setIsDeleteAction(false); } : () => { }}
                />)
                    : (<Unblock
                        style={{ marginRight: 15, opacity: data.ativavel ? 1 : '0.5', cursor: data.ativavel ? 'pointer' : 'default' }}
                        onClick={data.ativavel ? () => { setShowModalInactivate(true); setIsBlockAction(true); setIsDeleteAction(false); } : () => { }}
                    />)}
            </Tooltip>
            <Tooltip title="Excluir">
                <TrashBin
                    style={{ opacity: data.ativavel ? 1 : '0.5', cursor: data.ativavel ? 'pointer' : 'default' }}
                    onClick={data.ativavel ? () => { setShowModalInactivate(true); setIsBlockAction(false); setIsDeleteAction(true); } : () => { }}
                />
            </Tooltip>
        </>
    }


    const mountProportions = () => {
        const list = [...data.proporcoes]
        const clinico = list.filter((p: any) => { return p.tipoConsulta === 'clinica' })
        const periodico = list.filter((p: any) => { return p.tipoConsulta === 'periodica' })
        const preventivo = list.filter((p: any) => { return p.tipoConsulta === 'preventiva' })

        const clinicoProporc = clinico.length === 0 ? '0%' : String(clinico[0].proporcao) + '%'
        const periodicoProporc = periodico.length === 0 ? '0%' : String(periodico[0].proporcao) + '%'
        const preventivoProporc = preventivo.length === 0 ? '0%' : String(preventivo[0].proporcao) + '%'

        return clinicoProporc + ' / ' + periodicoProporc + ' / ' + preventivoProporc

    }

    const mountModalMsg = () => {
        const msg = 'Tem certeza que deseja '
            + (isBlockAction ? (isActive ? 'bloquear' : 'desbloquear') : 'excluir')
            + ' a agenda do dia ' + (data.data)
        const timeParticle = ' das ' + data.horaInicio + ' às ' + data.horaFim + '?'

        return msg + (isAgendaDiaria ? timeParticle : '?');
    }

    const goToAgendaDia = () => {
        return navigate(Paths.AgendaDias, { state: { nomeProfissional: profissionalInfo.nome, profissionalInfo: profissionalInfo, data: data, agenda: agenda } })
    }

    const onConfirmModalAction = () => {
        if (isAgendaDiaria) {
            if (isBlockAction) {
                activateInactivateAgendaMesDiaHorario(data.agendaId, data.turnoDiaId, data.id, !isActive);
            } else {
                deleteAgendaTurnoDiaHorario(data.agendaId, data.turnoDiaId, data.id)
            }
        } else {
            if (isBlockAction) {
                activateInactivateAgendaMesHorario(data.agendaId, data.turnoDiaId, !isActive);
            } else {
                deleteAgendaTurnoDia(data.agendaId, data.turnoDiaId)
            }
        }
        setShowModalInactivate(false)
    }
    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <ListItemContainer disabled={data.inativo}>
                {!isMobile ? (<Table>
                    <TableData width={'2%'} style={{ verticalAlign: 'middle' }}>
                        {(isActive && data.ativavel) && (<StyledCheckbox checked={isOnSelectedList} onChange={addObjectToSelectedList} />)}
                    </TableData>
                    <TableData width={'10%'} style={{ verticalAlign: 'middle' }}>
                        <div style={{ flexDirection: 'row', display: 'flex' }}>
                            <div>
                                <StyledText disabled={!isActive}>{data.data}</StyledText>
                            </div>
                        </div>
                    </TableData>
                    <TableData width={'15%'} style={{ verticalAlign: 'middle' }}>
                        <div style={{ flexDirection: 'row', display: 'flex' }}>
                            <div>
                                <StyledText disabled={!isActive}>{`${data.horaInicio} - ${data.horaFim}`}</StyledText>
                            </div>
                        </div>
                    </TableData>
                    <TableData width={'20%'} style={{ verticalAlign: 'middle' }}>
                        <div style={{ flexDirection: 'row', display: 'flex', verticalAlign: 'middle' }}>
                            <StyledText disabled={!isActive}>{data.unit?.nomeFantasia || 'Unidade não informada'}</StyledText>
                        </div>
                    </TableData>
                    {!isAgendaDiaria && (<TableData width={'20%'} style={{ verticalAlign: 'middle' }}>
                        {data.proporcoes.length > 0 ? (<StyledText>{mountProportions()}</StyledText>):(<StyledText>Sem proporcionalidade</StyledText>)}
                    </TableData>)}
                    <TableData width={'20%'} style={{ verticalAlign: 'middle' }}>
                        {!isAgendaDiaria && (<TextLink style={{ marginTop: 10, marginLeft: 40, fontWeight: 'bold', color: Colors.SPM500 }} onClick={goToAgendaDia}>{`VER AGENDA > `}</TextLink>)}
                    </TableData>
                    <TableData width={'5%'} style={{ verticalAlign: 'middle' }}>
                        <div style={{ flexDirection: 'row', display: 'flex' }}>
                            <ActionsArea />
                        </div>
                    </TableData>
                </Table>)
                    : (<MobileContainer>
                        <div style={{ flexDirection: 'row', display: 'flex' }}>
                            {isActive && (<StyledCheckbox checked={isOnSelectedList} onChange={addObjectToSelectedList} />)}
                            <div>
                                <StyledText disabled={!isActive}>{data.data}</StyledText>
                                <StyledText disabled={!isActive}>{data.unit?.nomeFantasia || 'Unidade não informada'}</StyledText>
                                <StyledText disabled={!isActive}>{`${data.horaInicio} - ${data.horaFim}`}</StyledText>
                                {!isAgendaDiaria && (<>
                                    {data.proporcoes.length > 0 && (<StyledText disabled={!isActive}>{`CLI/PERI/PREV: ${mountProportions()}`}</StyledText>)}
                                </>)}
                            </div>
                        </div>
                        <div style={{ marginTop: 40 }}>
                            <div style={{ flexDirection: 'row', display: 'flex', marginLeft: 10, marginBottom: 10 }}>
                                <ActionsArea />
                            </div>
                            {!isAgendaDiaria && (<TextLink style={{ marginTop: 10, fontWeight: 'bold', color: Colors.SPM500 }} onClick={goToAgendaDia}>{`VER AGENDA > `}</TextLink>)}
                        </div>
                    </MobileContainer>)}
            </ListItemContainer>

            <GenericModal
                visible={showModalInactivate}
                Icon={() => { return isBlockAction ? (!isActive ? <Unblock width="110" height="110" /> : <Block width="110" height="110" />) : <TrashBin width="110" height="110" /> }}
                onCancel={onConfirmModalAction}
                onConfirm={() => { setShowModalInactivate(false) }}
                modalTitle={mountModalMsg()}
                modalSubtitle={''}
                cancelButtonMsg={'Voltar'}
                confirmButtonMsg={isBlockAction ? (isActive ? 'Bloquear' : 'Desbloquear') : 'Excluir'}
            />
        </>
    )
    // --------------------------------------------------------
}

export default AgendaMesHorarioListItem